import Vue from 'vue';
import VueRouter from 'vue-router';
import { auth } from '@/firebaseConfig.ts';
import Login from '../views/pages/login.vue';
import SafetyIncident from '../views/pages/safetyIncident.vue';
import WellControlPost from '../views/pages/wellControlPost.vue';
import WellControlList from '../views/pages/wellControlList.vue';
import DrillingIncident from '../views/pages/drillingIncident.vue';
import Companies from '../views/company/companies.vue';
import Stats from '../views/stats/stats.vue';
import CompanyDetails from '../views/company/companyDetails.vue';
import Moderators from '../views/company/moderators.vue';
import Dashboard from '../views/dashboard.vue';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/safety/:id',
      name: 'safety',
      component: SafetyIncident,
    },
    {
      path: '/drilling/:id',
      name: 'drilling',
      component: DrillingIncident,
    },
    {
      path: '/wellControl',
      name: 'wellcontrol',
      component: WellControlList,
    },
    {
      path: '/wellControl/:id',
      name: 'wellcontrol',
      component: WellControlPost,
    },
    {
      path: '/',
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '/',
          name: 'stats',
          components: {
            dashboard: Stats,
          },
        },
        {
          path: '/companies',
          name: 'companies',
          components: {
            dashboard: Companies,
          },
        },
        {
          path: '/companies/:id',
          components: {
            dashboard: CompanyDetails,
          },
        },
        {
          path: '/moderators',
          components: {
            dashboard: Moderators,
          },
        },
        {
          path: '*',
          redirect: '/',
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },

    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    // },
  ],
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const { currentUser } = auth;
  console.log(currentUser);
  if (requiresAuth && !currentUser) next('login');
  if (!requiresAuth && currentUser) next();
  else next();
});

export default router;
